var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('bouncing-burger-overlay',{attrs:{"value":true}},[_vm._v("hello")]),_vm._v(" xxxx ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }